// extracted by mini-css-extract-plugin
export default {"page":"Index_page__DiHf2","introBox":"Index_introBox__mhz4k"};